export default {
    // System user status options
    filterByStatusOption: [
        { text: 'Filter by status', value: null },
        { text: 'Active', value: 'active' },
        { text: 'Pending', value: 'pending' },
        { text: 'Archived', value: 'archived' },
    ],

    // System user table fields
    systemUsersfields: [
        {
            key: 'profile',
            label: '',
            class: 'profile-absolute',
        },
        {
            key: 'firstName',
            label: 'Full Name',
            sortable: true,
            formatter: (value, key, item) => {
                return `${item.firstName} ${item.lastName}`
            },
        },
        // {
        //     key: 'username',
        //     label: 'User Name',
        //     sortable: true,
        //     // formatter: (value, key, item) => {
        //     //     return `${item.firstName} ${item.lastName}`
        //     // },
        // },
        {
            key: 'role.title',
            label: 'Role',
            sortable: true,
        },
        {
            key: 'invitedBy.firstName',
            label: 'Invited By',
            sortable: true,
        },
        {
            key: 'ref',
            label: 'ref',
            sortable: true,
        },
        {
            key: 'email',
            label: 'Email',
            sortable: true,
        },
        {
            key: 'phoneNumber',
            label: 'Phone Number',
            sortable: false,
        },
        {
            key: 'companyName',
            label: 'Company Name',
            sortable: false,
        },
        {
            key: 'createdAt',
            label: 'Join Date',
            sortable: true,
        },
        // {
        //     key: 'loginAt',
        //     label: 'Last Login',
        //     sortable: true,
        // },
        {
            key: 'status',
            label: 'Status',
            class: 'text-center status-absolute-pos',
            sortable: true,
        },
        {
            key: 'action',
            label: 'Action',
            sortable: false,
            class: 'text-center w-180px',
        },
    ],
    usersList: [],
}
